import { Layout, Menu } from "antd";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BooleanParam, useQueryParam } from "use-query-params";
import { appRoutes } from "config/appRoutes.config";
import LinkWithParams from "components/elements/LinkWithParams";
import getAuthority from "utils/getAuthority";
import setPathToRedirect from "helpers/setPathToRedirect";
import { useGetZammadBaseLinkQuery } from "store/masterdata";
import styles from "./Sider.module.less";

function Sider(): JSX.Element {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useQueryParam("collapsed", BooleanParam);
  const { pathname } = useLocation();
  const userRoles = getAuthority();
  const { data: zammadBaseLink } = useGetZammadBaseLinkQuery();

  const toggleCollapsed = () => {
    setCollapsed((prevCollapsed) => !prevCollapsed);
  };

  return (
    <Layout.Sider
      collapsible
      width={230}
      collapsed={!!collapsed}
      onCollapse={toggleCollapsed}
    >
      <Menu
        className={styles.menu}
        theme="light"
        mode="inline"
        selectedKeys={[pathname]}
      >
        {appRoutes.map(
          ({
            name,
            path,
            productionPath,
            Icon,
            hideInMenu,
            authority,
            external,
          }) => {
            const userHasRequiredRole =
              userRoles && authority
                ? authority.some((el) => userRoles.indexOf(el) !== -1)
                : true;
            const pathToRedirect = setPathToRedirect(productionPath, path);

            const isHidden = hideInMenu || !userHasRequiredRole;

            return isHidden ? null : (
              <Menu.Item key={pathToRedirect} icon={Icon ? <Icon /> : null}>
                {external ? (
                  <a
                    href={
                      pathToRedirect === "fromAPI"
                        ? zammadBaseLink
                        : pathToRedirect
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t(name)}
                  </a>
                ) : (
                  <LinkWithParams to={pathToRedirect}>{t(name)}</LinkWithParams>
                )}
              </Menu.Item>
            );
          }
        )}
      </Menu>
    </Layout.Sider>
  );
}

export default Sider;
